import { useMemo } from "react"
import {
    CargoTypeFilter,
    SortCriteria,
    TransportOrderStatusFilter,
    transportOrderSlice,
} from "./transportorder.slice"
import { useAppDispatch } from "./store"

export const useSearchTransportOrders = () => {
    const dispatch = useAppDispatch()
    return useMemo(() => (searchPhrase: string | undefined) => dispatch(transportOrderSlice.actions.searchTransportOrderBundles(searchPhrase)), [dispatch])
}

export const useSortTransportOrders = () => {
    const dispatch = useAppDispatch()
    return useMemo(() => (sortCriteria: SortCriteria | undefined) => dispatch(transportOrderSlice.actions.sortTransportOrderBundles(sortCriteria)), [dispatch])
}

export const useFilterTransportOrdersByCargoType = () => {
    const dispatch = useAppDispatch()
    return useMemo(() => (cargoTypeFilter: CargoTypeFilter) =>
        dispatch(transportOrderSlice.actions.filterTransportOrderBundlesByCargoType(cargoTypeFilter)), [dispatch])
}

export const useFilterTransportOrdersByStatus = () => {
    const dispatch = useAppDispatch()
    return useMemo(() => (statusFilter: TransportOrderStatusFilter) =>
        dispatch(transportOrderSlice.actions.filterTransportOrderBundlesByStatus(statusFilter)), [dispatch])
}
